import { TourProvider } from "@reactour/tour";

export default function AppTourProvider({ children }) {
    return (
        <TourProvider
            steps={[]}
            showBadge={false}
            showCloseButton
            styles={{
                popover: (base, { position }) => ({
                    ...base,
                    boxShadow: '0 0 10em rgba(0, 0, 0, 0.5)',
                    backgroundColor: position === 'top' ? '#dedede' : '#dedede',
                    borderRadius: 16,
                    paddingTop: 30,
                    padding: 20,
                }),
                maskArea: (base) => ({
                    ...base,
                    rx: 12,
                }),
            }}
        >
            {children}
        </TourProvider>
    );
}
